import platform from "platform";

export default async (resolve, reject, addLog) => {
  addLog(`Navigator used : ${platform.description}`);

  if (platform.name === "Chrome" && Number(platform.version.split(".")[0]) >= 78)
    resolve();
  else reject();
};
